export default function objectToFormData(obj) {
  let rootName;
  let formData = null;

  function appendFormData(data, rootData) {
    rootData = rootData || '';
    switch (typeof data) {
      case 'string':
        formData = (formData || new FormData());
        formData.append(rootData, data);
        break;
      case 'array':
        for (let i = 0; i < Object.keys(data).length; i++) {
          appendFormData(data[i], `${rootData}[${i}]`);
        }
        break;
      case 'object':
        if (data) {
          for (const key in data) {
            if (data.hasOwnProperty(key) && key !== 'undefined') {
              if (rootData === '') {
                appendFormData(data[key], key);
              } else {
                appendFormData(data[key], `${rootData}[${key}]`);
              }
            }
          }
        }
        break;
      default:
        if (data !== null && typeof data !== 'undefined') {
          formData = (formData || new FormData());
          formData.append(rootData, data);
        }
        break;
    }
  }

  appendFormData(obj, rootName);

  return formData;
}
